/**
 * Header Layout
 *
 * @file header.js
 */
import $ from 'jquery';


const header = (() => {
  const fixedHeader = () => {
  };

  const headerMenu = () => {
    $(".header-anim-menu .menu-toggle").on("click", function(){
      $("body").toggleClass("hidden");
      $(this).parent().toggleClass("active");
    });
  };

  const init = () => {
    fixedHeader();
    headerMenu();
  };

  return {
    init,
  };
})();

export default header;
